<script>
import { updateElementsVisibility } from '../utils/dom';
import TreePage from './tree.vue';

export default {
  name: 'RepositoryIndex',
  components: {
    TreePage,
  },
  props: {
    refType: {
      type: String,
      required: false,
      default: null,
    },
  },
  mounted() {
    this.updateProjectElements(true);
  },
  beforeDestroy() {
    this.updateProjectElements(false);
  },
  methods: {
    updateProjectElements(isShow) {
      updateElementsVisibility('.js-show-on-project-root', isShow);
    },
  },
};
</script>

<template>
  <tree-page :ref-type="refType" />
</template>
